import { render, staticRenderFns } from "./PixelExtractor.vue?vue&type=template&id=2587e200&"
import script from "./PixelExtractor.vue?vue&type=script&lang=js&"
export * from "./PixelExtractor.vue?vue&type=script&lang=js&"
import style0 from "./PixelExtractor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports